import { CirclePile } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const OfflineIcon = createLucideIcon(CirclePile);
